import L from 'leaflet';
import { envAssets } from '../environment';

let wineryIcon = new L.icon({
    iconUrl: envAssets('images/icons/pin-03.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [30, 41],
    iconAnchor: [12, 41],
    shadowSize: [30, 33],
    shadowAnchor: [6, 33],
})
let natureIcon = new L.icon({
    iconUrl: envAssets('images/icons/pin-02.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [30, 41],
    iconAnchor: [12, 41],
    shadowSize: [30, 33],
    shadowAnchor: [6, 33],
})
let culturalIcon = new L.icon({
    iconUrl: envAssets('images/icons/pin-01.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [30, 41],
    iconAnchor: [12, 41],
    shadowSize: [30, 33],
    shadowAnchor: [6, 33],
})

let wineryIconBigger = new L.icon({
    iconUrl: envAssets('images/icons/pin-03.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [45, 57],
    iconAnchor: [18, 57],
    shadowSize: [45, 33],
    shadowAnchor: [11, 33],
})
let natureIconBigger = new L.icon({
    iconUrl: envAssets('images/icons/pin-02.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [45, 57],
    iconAnchor: [18, 57],
    shadowSize: [45, 33],
    shadowAnchor: [11, 33],

})
let culturalIconBigger = new L.icon({
    iconUrl: envAssets('images/icons/pin-01.png'),
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [45, 57],
    iconAnchor: [18, 57],
    shadowSize: [45, 33],
    shadowAnchor: [11, 33],
})

export default function tourPinColorHandler(tour, clickedTourId) {
    if (tour?.id === clickedTourId) {
        switch (tour?.type) {
            case 'culture':
                return culturalIconBigger;
            case 'nature':
                return natureIconBigger;
            case 'winery':
                return wineryIconBigger;
            default:
                return new L.Icon.Default();
        }
    } else {
        switch (tour?.type) {
            case 'culture':
                return culturalIcon;
            case 'nature':
                return natureIcon;
            case 'winery':
                return wineryIcon;
            default:
                return new L.Icon.Default();
        }
    }
}